import { FC, ReactNode } from 'react'
import { NotificationState } from '@/states'
import { BellIcon } from '@heroicons/react/16/solid'

const Notification: FC = (): ReactNode => {
    const { Notifications } = NotificationState()

    return (
        <div className='absolute bottom-3 left-1/2 transform -translate-x-1/2 flex flex-col gap-2 z-[200] ignore-blur'>
            {
                Notifications?.map((notification: NotificationInterface) => {
                    const { Id, Title } = notification

                    return (
                        <div key={Id} className='flex border-[#424242] border items-center w-full max-w-xs p-3 text-[#CDD5DA] bg-[#262626] rounded-md ignore-blur'>
                            <BellIcon className='flex-shrink-0 w-4 h-4 text-[#CDD5DA] transition duration-75 group-hover:text-[#CDD5DA] ignore-blur' />

                            <div className='ms-2 border-s border-[#424242] ps-2 text-[13px] font-normal ignore-blur'>
                                {Title}
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default Notification
